<micro-lookup domain="auth" obj="contactsByPhone" [key]="contactId"></micro-lookup>
